import * as React from 'react'

class TabFootnote extends React.Component {

  render() {
    return (
      <div style={{ padding: '25px' }}>
        <small>
          <i>
            {this.props.children}
          </i>
        </small>
      </div>
    )
  }
}

export default TabFootnote;


// WEBPACK FOOTER //
// ./src/app/components/tabs/TabFootnote/index.tsx